import { type IconProps, Icon } from "@chakra-ui/icon";

const CalendarIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 8.83317H2.5M13.3333 2.1665V5.49984M6.66667 2.1665V5.49984M6.5 18.8332H13.5C14.9001 18.8332 15.6002 18.8332 16.135 18.5607C16.6054 18.321 16.9878 17.9386 17.2275 17.4681C17.5 16.9334 17.5 16.2333 17.5 14.8332V7.83317C17.5 6.43304 17.5 5.73297 17.2275 5.19819C16.9878 4.72779 16.6054 4.34534 16.135 4.10565C15.6002 3.83317 14.9001 3.83317 13.5 3.83317H6.5C5.09987 3.83317 4.3998 3.83317 3.86502 4.10565C3.39462 4.34534 3.01217 4.72779 2.77248 5.19819C2.5 5.73297 2.5 6.43304 2.5 7.83317V14.8332C2.5 16.2333 2.5 16.9334 2.77248 17.4681C3.01217 17.9386 3.39462 18.321 3.86502 18.5607C4.3998 18.8332 5.09987 18.8332 6.5 18.8332Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default CalendarIcon;
